import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HealthArticle, Tag, Promoter } from '@app/_models/health';
import { environment } from '@environments/environment';
import { SessionService } from '../session.service';

@Injectable({ providedIn: 'root' })
export class HealthService {
  constructor(
    private httpClient: HttpClient,
    private _sessionService: SessionService
  ) { }
  user = this._sessionService.currentUser.user;
  facility = this._sessionService.currentFacility.id;

  getArticles(): Observable<HealthArticle[]> {
    const url = `${environment.apiUrl}/articles/`;
    return this.httpClient.get<HealthArticle[]>(url);
  }

  getArticle(id: number): Observable<HealthArticle> {
    const url = `${environment.apiUrl}/articles/${id}/`;
    return this.httpClient.get<HealthArticle>(url);
  }

  createArticle(article: FormData): Observable<HealthArticle> {
    article.append('user', this.user.toString());
    article.append('facility', this.facility.toString());
    const url = `${environment.apiUrl}/articles/`;
    return this.httpClient.post<HealthArticle>(url, article);
  }

  updateArticle(article: FormData, id: number): Observable<HealthArticle> {
    article.append('user', this.user.toString());
    article.append('facility', this.facility.toString());
    const url = `${environment.apiUrl}/articles/${id}/`;
    return this.httpClient.put<HealthArticle>(url, article);
  }

  deleteArticle(id: number): Observable<HealthArticle> {
    const url = `${environment.apiUrl}/articles/${id}/`;
    return this.httpClient.delete<HealthArticle>(url);
  }

  getTags(): Observable<Tag[]> {
    const url = `${environment.apiUrl}/tags/`;
    return this.httpClient.get<Tag[]>(url);
  }

  getTagsByArticleId(id: number): Observable<Tag[]> {
    const url = `${environment.apiUrl}/articles/${id}/tags/`;
    return this.httpClient.get<Tag[]>(url);
  }

  createTag(name: string): Observable<Tag> {
    const url = `${environment.apiUrl}/tags/`;
    return this.httpClient.post<Tag>(url, { name });
  }

  deleteTag(id: number): Observable<string> {
    const url = `${environment.apiUrl}/tags/${id}/`;
    return this.httpClient.delete<string>(url);
  }

  getPromoters(): Observable<Promoter[]> {
    const url = `${environment.apiUrl}/promoters/`;
    return this.httpClient.get<Promoter[]>(url);
  }

  getPromotersByArticleId(id: number): Observable<Promoter[]> {
    const url = `${environment.apiUrl}/articles/${id}/promoters/`;
    return this.httpClient.get<Promoter[]>(url);

  }

  createPromoter(promoter: FormData): Observable<Promoter> {
    const url = `${environment.apiUrl}/promoters/`;
    return this.httpClient.post<Promoter>(url, promoter);
  }

  findHealthArticles(
    pageNumber: number,
    pageSize: number,
    status: number): Observable<HealthArticle[]> {

    const url = `${environment.apiUrl}/articles/`;

    return this.httpClient.get<HealthArticle[]>(url, {
      params: new HttpParams()
        .set('pageNumber', pageNumber.toString())
        .set('pageSize', pageSize.toString())
        .set('status', status.toString())
    });
  }

}
